//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FilterWrapperMobile from '../../components/FilterWrapperMobile';
import PaidFilters from './PaidFilters';
import {
  setStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  downloadCsv
} from './CommissionPaidIndex/reducer';

type Props = {
  location: Location,
  viewportDevice: string,
  statusFilter: string,
  setStatusFilter: () => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart: string,
  calendarEnd: string,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: () => void,
  setCalendarEndFilter: () => void,
  setCalendarSaga: () => void,
  downloadCsv: string => void
};

class FilterBlock extends Component<Props> {
  handleCsv = () => {
    this.props.downloadCsv('referral_details');
  };
  render() {
    const filterEnabled =
      this.props.location.pathname === '/commission-payouts/paid';

    const availableFilters = { status: ['Pending', 'Paid'] };
    return (
      <FilterWrapperMobile
        title={'Commissions Paid'}
        downloadCsv={this.handleCsv}
        disabled={!filterEnabled}
      >
        <PaidFilters
          statusFilter={this.props.statusFilter}
          setStatusFilter={this.props.setStatusFilter}
          toggleCalendarFilter={this.props.toggleCalendarFilter}
          calendarFilterState={this.props.calendarFilterState}
          calendarStart={this.props.calendarStart}
          calendarEnd={this.props.calendarEnd}
          clearCalendarFilter={this.props.clearCalendarFilter}
          setCalendarStartFilter={this.props.setCalendarStartFilter}
          setCalendarEndFilter={this.props.setCalendarEndFilter}
          windowSize={this.props.viewportDevice}
          setCalendarSaga={this.props.setCalendarSaga}
          availableFilters={availableFilters}
          disabled={!filterEnabled}
          downloadPaidCsv={this.handleCsv}
        />
      </FilterWrapperMobile>
    );
  }
}

const mapStateToProps = state => ({
  statusFilter: state.commissionPayouts.commissionPaid.index.statusFilter,
  viewportDevice: state.global.viewportDevice,
  calendarFilterState:
    state.commissionPayouts.commissionPaid.index.calendarFilterState,
  calendarStart: state.commissionPayouts.commissionPaid.index.calendarStart,
  calendarEnd: state.commissionPayouts.commissionPaid.index.calendarEnd
});

const mapDispatchToProps = {
  setStatusFilter,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  downloadCsv
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FilterBlock)
);
